import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	PRODUCTINTEREST_REQUEST,
	PRODUCTINTEREST_CREATE,
	PRODUCTINTEREST_DELETE,
	PRODUCTINTEREST_EDIT,
	PRODUCTINTEREST_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { ToastContainer, toast } from 'react-toastify';

const ProductInterest = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchProductInterests,
	submitProductInterestCreate,
	submitProductInterestDelete,
	submitProductInterestEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteProductInterestId, setDeleteProductInterestId] = useState('');
	const [editProductInterestId, setEditProductInterestId] = useState('');
	const [editProductInterestName, setEditProductInterestName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchProductInterests(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("Product Interest Created Successfully.");
			fetchProductInterests(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("Product Interest Deleted Successfully.");
			fetchProductInterests(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("Product Interest Data Updated Successfully.");
			fetchProductInterests(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create Product Interest create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("Product Interest name cannot be empty.");
		} else {
			submitProductInterestCreate({
				"data": {
					"ProductInterestName": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteProductInterestId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteProductInterestId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete Product Interest delete api
	const handleConfirmDeleteSubmit = () => {
		submitProductInterestDelete({
			"productInterestId": deleteProductInterestId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditProductInterestId(data.productInterestId);
		setEditProductInterestName(data.productInterestName);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editProductInterestName === '') {
			toast.error("Product Interest name cannot be empty.");
		} else {
			submitProductInterestEdit({
				"data": {
					"productInterestId": data.productInterestId,
					"productInterestName": editProductInterestName
				},
				"token": auth[0].token
			});
			setEditProductInterestId('');
			setEditProductInterestName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">
					<ToastContainer />
					<div className="sub-header mt-5 mb-3">
						<h2>Product Interests</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`Product Interest`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>Product Interest Name</th>
								<th width="50" className="actions">
									<div className="d-flex">
										<span>Delete</span>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editProductInterestId === item.productInterestId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editProductInterestName} onChange={(evt) => setEditProductInterestName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.productInterestName}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`Product Interest`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.productInterestId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	)
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchProductInterests: (token) => dispatch({ type: PRODUCTINTEREST_REQUEST, token }),
		submitProductInterestCreate: (data) => dispatch({ type: PRODUCTINTEREST_CREATE, payload: data }),
		submitProductInterestDelete: (data) => dispatch({ type: PRODUCTINTEREST_DELETE, payload: data }),
		submitProductInterestEdit: (data) => dispatch({ type: PRODUCTINTEREST_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: PRODUCTINTEREST_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductInterest);